export const DATE_FORMAT = "d. MMMM yyyy";
export const TIMESTAMP_FORMAT = "dd.MM.yyyy HH:mm";
export const UTKAST_FORMAT = "d. MMMM yyyy 'kl.' HH:mm";
